import { useEffect, useState } from 'react';

const quotes = [
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "Done is better than perfect.", author: "Sheryl Sandberg" },
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "Small progress is still progress.", author: "Anonymous" },
  { text: "Focus on being productive instead of busy.", author: "Tim Ferriss" },
  { text: "Your time is limited, don't waste it.", author: "Steve Jobs" },
  { text: "The best way to predict the future is to create it.", author: "Peter Drucker" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Productivity is never an accident. It is always the result of commitment.", author: "Paul J. Meyer" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Don't count the days, make the days count.", author: "Muhammad Ali" },
  { text: "Success is not final, failure is not fatal.", author: "Winston Churchill" },
  { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
  { text: "Action is the foundational key to all success.", author: "Pablo Picasso" },
  { text: "Success usually comes to those who are too busy to be looking for it.", author: "Henry David Thoreau" },
  { text: "The harder you work for something, the greater you'll feel when you achieve it.", author: "Anonymous" },
  { text: "Don't watch the clock; do what it does. Keep going.", author: "Sam Levenson" },
  { text: "Success is not in what you have, but who you are.", author: "Bo Bennett" },
  { text: "The difference between ordinary and extraordinary is that little extra.", author: "Jimmy Johnson" },
  { text: "The only limit to our realization of tomorrow will be our doubts of today.", author: "Franklin D. Roosevelt" },
  { text: "What you do today can improve all your tomorrows.", author: "Ralph Marston" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "The key to success is to focus on goals, not obstacles.", author: "Anonymous" },
  { text: "Success is walking from failure to failure with no loss of enthusiasm.", author: "Winston Churchill" },
  { text: "Your attitude determines your direction.", author: "Anonymous" },
  { text: "Every accomplishment starts with the decision to try.", author: "Anonymous" },
  { text: "Dream big, start small, but most of all, start.", author: "Simon Sinek" },
  { text: "The expert in anything was once a beginner.", author: "Helen Hayes" }
];

export function InspirationQuote() {
  const [currentQuote, setCurrentQuote] = useState(quotes[0]);

  useEffect(() => {
    // Change quote every 10 seconds
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * quotes.length);
      setCurrentQuote(quotes[randomIndex]);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full bg-gradient-to-r from-purple-900/20 to-blue-900/20 py-2 px-4">
      <div className="container mx-auto text-center">
        <p className="text-sm font-semibold">
          <span className="text-slate-900">&ldquo;{currentQuote.text}&rdquo;</span>
          <span className="text-slate-800 ml-2">- {currentQuote.author}</span>
        </p>
      </div>
    </div>
  );
} 